import React from "react";
// import PageHeader from "../common/PageHeader/PageHeader";
import OptimizationReportTable from "./optimizationReportTable";
import { ReportContext } from "../../layout/Content/MainContent.component";
import useTvWeeklyScheduleStyles from "../tv-weekly-sch/tvWeeklySchedule.style";
import Button from "@material-ui/core/Button";
import { green } from "@material-ui/core/colors";
import {
  createMuiTheme,
  ThemeProvider
} from "@material-ui/core/styles";

function OptimizationPage() {
  const {
    userInfo,
    navigateToCreateNewReport,
    enableAutoRefresh,
  } = React.useContext(ReportContext);
  const theme = createMuiTheme({
    palette: {
      primary: green
    }
  });
  const classes = useTvWeeklyScheduleStyles();
  return (
    <div style={{ marginTop: 20 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 20px",
          width: "70%",
          margin: "auto"
        }}
      >
        <ThemeProvider theme={theme}>
          <Button
            variant="contained"
            color="primary"
            style={{
              color: "white",
              //fontSize: "9px",
              fontFamily: "OpenSans",
              top: "1px"
            }}
            onClick={navigateToCreateNewReport}
          >
            CREATE NEW REPORT
          </Button>
        </ThemeProvider>
      </div>
      <div>
        <OptimizationReportTable enableAutoRefresh={enableAutoRefresh} userInfo={userInfo} />
      </div>
    </div>
  );
}

export default OptimizationPage;
